<template>
  <el-dialog :title="$t('message.修改面试状态')" :visible.sync="innerVisible" width="35%" center :top="dialogTop">
    <div class="center">
      <div>
        <el-select v-model="form.interview_status" placeholder='请选择'>
          <el-option
            v-for="status in interviewStatus"
            :label="status.label"
            :key="status.value"
            :value="status.value"></el-option>
        </el-select>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" :style="footerStyle">
      <el-button class="btn-close-dialog" type="primary" @click="close">{{ $t('message.关闭') }}</el-button>
      <el-button class="btn-save-dialog" type="primary" @click="saveStatus">{{ $t('message.保存') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { interviewStatus } from '../../dataset/interview';
import dialogMixin from './dialogMixin';
import { jmAssetUpload } from '@/components/tool';

export default {
  mixins: [dialogMixin],
  components: {
    jmAssetUpload
  },
  props: {
    interview: {
      type: Object,
      require: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      interviewStatus,
      form: {},
      fileList: [],
      dialogTop: '35vh',
      footerStyle: {
        paddingLeft: '220px'
      }
    };
  },
  computed: {
    interviewDate() {
      return this.interview.interview_time;
    },
    cannotSave() {
      if (!this.isInterviewer) {
        return true;
      }
      if (this.hasResult) {
        return true;
      }
      return false;
    },
    hasResult() {
      return !!this.form.originResult;
    },
    isInterviewer() {
      return this.$hasPermission([108], true);
    }
  },
  watch: {
    interview(v) {
      if (v) {
        this.form = { ...this.form, ...v };
      }
    }
  },
  methods: {
    async saveStatus() {
      await this.$http._post({
        url: '/interview/plan/saveStatus',
        data: { data: this.form }
      });
      this.$message.success(this.$t('message.修改面试状态成功'));
      this.innerVisible = false;
    }
  }
};
</script>
<style scoped>
.center {
  text-align: center;
}
.center h4 {
  font-size: 20px;
  padding: 10px;
}
</style>
